/**
 * Check input errors
 * @param {Array} missingInputsList
 * @param {String} emailErrorText
 * @param {String} passwordErrorText
 * @param {String} phoneNumberErrorText
 * @return {Boolean}
*/
const checkInputErrors = (
  missingInputsList,
  emailErrorText,
  passwordErrorText,
  phoneNumberErrorText
) => {
  if (!missingInputsList.length &&
      !emailErrorText &&
      !passwordErrorText &&
      !phoneNumberErrorText) {
    return true;
  }
  return false;
};

export default checkInputErrors;